import { ReactNode } from "react";
import styled from "styled-components";

export const GenericButtonAtom = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    background-color: rgba(255, 255, 255, 0.3);
    font-family: 'FixelVariable', 'Fira Code', sans-serif;
    color: white;
    border-radius: 1000px;
    cursor: pointer;
    transition: background 300ms;

    &:hover {
        background-color: rgba(255, 255, 255, 0.5);
    }
`

export interface GenericButtonProps {
    children?: Array<ReactNode> | ReactNode | String
}